import React, { useEffect, useRef, useState } from 'react';

const Partners = () => {
  const sectionRef = useRef(null);
  const [cardsVisible, setCardsVisible] = useState(false);

  // Past/Existing Clients
  const clients = [
    {
      name: 'Cambria',
      logo: '/logos/cambria.png',
      xProfile: 'https://x.com/playcambria'
    },
    {
      name: 'The Beacon',
      logo: '/logos/beacon.png',
      xProfile: 'https://x.com/The_Beacon_GG'
    },
    {
      name: 'CARV',
      logo: '/logos/carv.jpg',
      xProfile: 'https://x.com/carv_official'
    },
    {
      name: 'Somnis: Rumble Rush',
      logo: '/logos/somnis.png',
      xProfile: 'https://x.com/somnis_world'
    },
    {
      name: 'Pixel Heroes Adventure',
      logo: '/logos/pha.jpg',
      xProfile: 'https://x.com/PixelHeroesMMO'
    },
    {
      name: 'DAR Network',
      logo: '/logos/dar.png',
      xProfile: 'https://x.com/DarOpenNetwork'
    },
    {
      name: 'Mawari',
      logo: '/logos/mawari.jpg',
      xProfile: 'https://x.com/mawariXR'
    },
    {
      name: 'Eternum',
      logo: '/logos/realms.png',
      xProfile: 'https://x.com/realms_gg'
    },
    {
      name: 'Spekter Agency',
      logo: '/logos/spekter.jpg',
      xProfile: 'https://x.com/SpekterAgency'
    },
    {
      name: 'Chillchat',
      logo: '/logos/chillchat.jpg',
      xProfile: 'https://x.com/ChillchatGames'
    },
    {
      name: 'Immortal Rising 2',
      logo: '/logos/im2.jpg',
      xProfile: 'https://x.com/immortalrising2'
    }
  ];

  // Advisory under YP
  const advisory = [
    {
      name: 'Virtuals Protocol',
      logo: '/logos/virtuals.jpg',
      xProfile: 'https://x.com/virtuals_io'
    },
    {
      name: 'OVERTAKE',
      logo: '/logos/overtake.png',
      xProfile: 'https://x.com/overtake_world'
    },
    {
      name: 'Renaiss Protocol',
      logo: '/logos/renaiss.jpg',
      xProfile: 'https://x.com/renaissxyz'
    },
    {
      name: 'CARV',
      logo: '/logos/carv.jpg',
      xProfile: 'https://x.com/carv_official'
    },
    {
      name: 'Cambria',
      logo: '/logos/cambria.png',
      xProfile: 'https://x.com/playcambria'
    },
    {
      name: 'YGG Play',
      logo: '/logos/ygggplay.png',
      xProfile: 'https://x.com/YGG_Play'
    },
    {
      name: 'Planetarium',
      logo: '/logos/planetarium.png',
      xProfile: 'https://x.com/planetariumhq'
    },
    {
      name: 'Sovrun',
      logo: '/logos/sovrun.jpg',
      xProfile: 'https://x.com/SovrunOfficial'
    }
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setCardsVisible(true);
          observer.unobserve(entry.target);
        }
      },
      {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
      }
    );

    const currentRef = sectionRef.current;
    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, []);

  const renderPartnerGrid = (partners) => (
    <div className="partners-minimal">
      {partners.map((partner, index) => (
        <a
          key={index}
          href={partner.xProfile}
          className={`partner-minimal ${cardsVisible ? 'visible' : ''}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className="partner-logo-container">
            <img
              src={partner.logo}
              alt={partner.name}
              className="partner-logo-minimal"
            />
            <div className="logo-hover-effect"></div>
          </div>
          <span className="partner-name-minimal">{partner.name}</span>
        </a>
      ))}
    </div>
  );

  return (
    <section className="partners" ref={sectionRef}>
      <div className="container">
        {/* Section 1: Past/Existing Clients */}
        <div className="section-header-experimental">
          <div className="header-decoration">
            <div className="decoration-line"></div>
            <h2>Past/Existing Clients</h2>
            <div className="decoration-line"></div>
          </div>
          <p>Projects we've helped grow and succeed</p>
        </div>
        {renderPartnerGrid(clients)}

        {/* Section 2: Advisory under YP */}
        <div className="section-header-experimental" style={{ marginTop: '4rem' }}>
          <div className="header-decoration">
            <div className="decoration-line"></div>
            <h2>Advisory under YP</h2>
            <div className="decoration-line"></div>
          </div>
          <p>Strategic advisory partnerships</p>
        </div>
        {renderPartnerGrid(advisory)}
      </div>
    </section>
  );
};

export default Partners;